var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverflowImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 70,
    viewBox: "0 0 197 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 -83.1667C18.9457 -83.1667 -32.1667 -32.0543 -32.1667 30.9999C-32.1667 94.0542 18.9457 145.167 82 145.167C145.054 145.167 196.167 94.0542 196.167 30.9999C196.167 -32.0543 145.054 -83.1667 82 -83.1667ZM82 122.333L104.833 99.4999L116.25 88.0832V65.2499H93.4167V53.8333L82 42.4166H47.75V76.6666L70.5833 99.4999V121.545C25.6017 115.894 -9.33334 77.4886 -9.33334 30.9999L2.08333 42.4166H24.9167V19.5832H47.75L82 -14.6667V-37.5001H59.1667L47.75 -48.9167V-53.609C69.7057 -62.5622 94.2943 -62.5622 116.25 -53.609V-37.5001L104.833 -26.0834V-3.25008L116.25 8.16658L151.984 -27.5676C160.677 -17.1678 166.941 -4.96004 170.319 8.16658H150.5L127.667 30.9999V53.8333L139.083 65.2499H161.917L165.182 68.5151C150.831 100.196 118.979 122.333 82 122.333Z",
    fill: "url(#paint0_linear_2277_3795)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2277_3795",
    x1: -96.3175,
    y1: -158.191,
    x2: 227.698,
    y2: 146.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverflowImg);
export default __webpack_public_path__ + "static/media/overflowImg.79b0bc1193cc50d3509a57106bd5e854.svg";
export { ForwardRef as ReactComponent };